import styled from 'styled-components';
export const LinkButtonBlueWrapper = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-weight: 700;
  letter-spacing: 0.15px;
  line-height: 30px;
  font-size: 12px;
  color: ${props => props.disabled ? 'rgba(53, 59, 96, 0.15)' : '#4C5ECF'};
  padding: 0 9px 0 9px;
  width: max-content;
  background: inherit;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  text-decoration: none;
  opacity: 1;
  height: max-content;
  transition: all ease-out 0.1s;

  & path {
    fill: ${props => props.disabled ? 'rgba(53, 59, 96, 0.15)' : '#4C5ECF'};
    transition: all 0.1s ease-out;
  }

  &:hover {
    ${props => !props.disabled && 'background: rgba(53, 59, 96, 0.1);'}
  }

  &:active {
    ${props => !props.disabled && 'background: rgba(53, 59, 96, 0.2);'}
  }
`;
export const ForeignWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 15px;
  min-width: 15px;
  margin-left: 7px;
`;